import { useQuestionnaireContext } from "@/contexts/QuestionnaireContext";
import { ExamResult, GruposExames } from "./types";

export const useExamDataProcessing = () => {
  const { historyValues } = useQuestionnaireContext();

  const processHistoricalData = () => {
    const responseEntries = historyValues?.map((el: any) => el?.resource);

    const examResultResponses = responseEntries?.map((itemResponse: any) => {
      const questionnaireResponseId = itemResponse?.id;
      const patient = itemResponse?.subject?.reference?.split("-")?.[1];
      const answerDate = itemResponse?.authored;
      const filterItems = itemResponse?.item
        ?.filter((e: any) => e?.text === "Resultado de exames")?.[0]
        ?.item?.filter((subItem: any) => {
          return subItem?.item?.[0]?.answer;
        });
      const displayReferences = itemResponse?.item?.filter(
        (e: any) => e?.linkId === "displayReferences"
      )?.[0]?.item;
      const displayInfo = {
        healthcare: displayReferences?.[0]?.answer?.[0]?.valueString || "",
        practitioner: displayReferences?.[1]?.answer?.[0].valueString || "",
        identifier: itemResponse?.author?.reference?.split("-")?.[1],
      };
      return { answerDate, filterItems, displayInfo, questionnaireResponseId, patient };
    });

    return examResultResponses
      ?.filter((el: any) => el?.filterItems?.length)
      ?.flatMap((item: any) => {
        const auxItem = item?.filterItems?.map((response: any) => {
          return {
            ...response,
            displayInfo: item?.displayInfo,
            answerDate: item?.answerDate,
            questionnaireResponseId: item?.questionnaireResponseId,
            patient: item?.patient,
          };
        });
        return auxItem;
      });
  };

  const groupExamsByName = (exams: ExamResult[]): GruposExames => {
    const grupos: GruposExames = {};
    exams?.forEach((exame) => {
      const nomeExameItem = exame?.item?.find(
        (item) => item?.text === "Nome do exame"
      );
      if (nomeExameItem) {
        const nomeExame = nomeExameItem?.answer?.[0]?.valueString;
        if (nomeExame === undefined) return;
        if (!grupos[nomeExame]) {
          grupos[nomeExame] = [];
        }
        grupos[nomeExame].push(exame);
      }
    });
    return grupos;
  };

  return {
    processHistoricalData,
    groupExamsByName,
  };
};
